/* @flow strict */

export const GET: 'GET' = 'GET';
export const POST: 'POST' = 'POST';
export const PUT: 'PUT' = 'PUT';
export const DELETE: 'DELETE' = 'DELETE';

export type MethodType = typeof GET | typeof POST | typeof PUT | typeof DELETE;
